import {
  Component,
  ViewChild,
  TemplateRef,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import {
  faTimes,
  faCheck,
  faTimesCircle,
  faInfoCircle,
  faToggleOn,
  faToggleOff,
} from "@fortawesome/pro-solid-svg-icons";
import { ValuationPageDataService } from "../valuation-page-data.service";
import { getExtraLogDetails } from "../valuation-page-utils";
import { ValuationPageState } from "../valuation-page.model";
import {
  CHARTS_TAB,
  COMPANY_TAB,
  VS_PEER_TAB,
  VALUATION_LOG_ACTION_FEATURES,
  VALUATION_PAGE,
} from "../valuation-page.constant";
import { ActivatedRoute } from "@angular/router";
import { Subscription, forkJoin } from "rxjs";
import { CompsDataService } from "../../comps-page/comps-data.service";
import { Store } from "@ngrx/store";
import {
  DeleteDpParams,
  SetDisableActions,
} from "src/app/store/actions/global-subheader.actions";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { AppService } from "src/app/app.service";
import { Dictionary } from "src/app/store/models/common_types";
import { MARKETDATA_COPYRIGHT_MESSAGE } from "src/app/common-constants";
import {
  VAIconRegistryService,
  close,
  check,
  closeCircle,
  infoCircle,
} from "@va/core-library/icons";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-valuation-page",
  templateUrl: "./valuation-page.component.html",
  styleUrls: ["./valuation-page.component.scss"],
  host: { class: "valuation-page-component" },
})
export class ValuationPageComponent implements OnInit, OnDestroy {
  sli_methodology =
    environment.SUPPORT_LINKS.base_link +
    environment.SUPPORT_LINKS.en_US +
    environment.SUPPORT_LINKS.articles.sli_methodology;
  vsPeerTab = VS_PEER_TAB.label;
  companyTab = COMPANY_TAB.label;
  chartsTab = CHARTS_TAB.label;
  selectedTabIndex = VS_PEER_TAB.index;
  legacyUrl = `${window.caUrl}/home`;
  marketDataAccess: boolean;
  currentYear: number = new Date().getFullYear();
  selectedTab = "vsPeerTab";

  //icons
  faTimes = faTimes;
  faCheck = faCheck;
  faTimesCircle = faTimesCircle;
  faInfoCircle = faInfoCircle;
  faToggleOn = faToggleOn;
  faToggleOff = faToggleOff;

  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  vsPeersTabInitialized = false;
  companyTabInitialized = false;
  chartTabInitialized = false;
  gapSwitch = false;
  state: ValuationPageState = {
    vsPeerTab: {},
    companyTab: {},
    chartTab: {},
  };
  currentTicker = undefined;
  currentCompanyId = undefined;
  watchlistData: Array<any> = [];
  addColTableData: Array<any> = [];
  recentlyVisitedCompanies: Array<any> = [];
  suggestedPeers: Array<any> = [];
  tabMapping = {
    0: VS_PEER_TAB.id,
    1: COMPANY_TAB.id,
    2: CHARTS_TAB.id,
  };
  legendColors: any;
  lineInfoDict: any;
  legendShapes: any;
  selectedRatios: Array<any>;
  marketDataCopyRightMessage = MARKETDATA_COPYRIGHT_MESSAGE;
  fetchedWatchlistData = false;
  watchListAndRecentCompaniesData;

  // loaders
  isWatchListAndRecentCompDataReady = false;
  isPeersDataReady = false;
  isVsPeerMetaInProgress = false;
  isCompanyMetaInProgress = false;
  isChartMetaInProgress = false;
  isUserPeriodCalSettingsInProgress = false;

  //subscribers
  routeParamSubscriber: Subscription;
  globalAppSettingSubscriber: Subscription;

  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "",
  };

  constructor(
    private dataService: ValuationPageDataService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private compDataService: CompsDataService,
    private iconRegistry: VAIconRegistryService,
    private appService: AppService,
  ) {
    this.iconRegistry.registerIcons([closeCircle, check, close, infoCircle]);
  }

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    this.snackBarRef.dismiss();
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
    };
    if (typeMap[type]) {
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: 5000,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type);
  }

  ngOnInit() {
    this.routeParamSubscriber = this.route.params.subscribe((paramData) => {
      this.currentTicker = paramData.ticker
        ? paramData.ticker.toUpperCase()
        : undefined;
      this.getMeta(0, this.currentTicker);

      this.appService.logUserAction(
        {},
        this.currentTicker,
        "",
        VALUATION_LOG_ACTION_FEATURES.pageVisit,
        {},
        "",
        VALUATION_PAGE,
      );
    });

    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of state on the tabs to trigger data calls
          this.updatevsPeerTabData(this.state.vsPeerTab);
          this.updateCompanyTabData(this.state.companyTab);
          this.updateChartTabData(this.state.chartTab);
        }
      });
  }

  /**
   * It call the meta api according to selected tab.
   * It retrieves response and creates the state info required fro that tab
   * If user doesn't has access to api, it will redirect to home page
   * It user doesn't has access to marketdata, it show the alert message
   */
  getMeta(index: number, ticker: string) {
    if (index === 0) {
      this.isVsPeerMetaInProgress = true;
    } else if (index === 1) {
      this.isCompanyMetaInProgress = true;
    } else if (index === 2) {
      this.isChartMetaInProgress = true;
    }
    this.dataService
      .getValuationPageMeta(ticker, this.tabMapping[index])
      .subscribe((metaData) => {
        if (metaData.status === "success") {
          this.marketDataAccess = metaData.marketdata_access;
          if (!this.marketDataAccess) {
            this.snackbarInfo.message = `You are currently not entitled to view Market/Valuation data. Please reach out to your Customer Success Manager if you require access.`;
            this.snackbarInfo.type = "info";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }
          const formattedTickerInfo = metaData.data.ticker_info.map((item) => {
            if (item.ticker === ticker) {
              this.currentCompanyId = item.cid;
            }
            return {
              ...item,
              full_name: item.name,
              tickerDeleteDisabled: item.ticker === ticker,
            };
          });

          if (index === 0) {
            this.createvsPeerTab(metaData.data, formattedTickerInfo);
            this.vsPeersTabInitialized = true;
            // Update ticker suggestion list
            this.getSuggestedTickerData(formattedTickerInfo);

            this.isVsPeerMetaInProgress = false; // Keep this as last statement of this block
          } else if (index === 1) {
            this.createCompanyTab(metaData.data, formattedTickerInfo);
            this.companyTabInitialized = true;

            this.isCompanyMetaInProgress = false; // Keep this as last statement of this block
          } else if (index === 2) {
            this.createChartTab(metaData.data, formattedTickerInfo);
            this.chartTabInitialized = true;

            this.isChartMetaInProgress = false; // Keep this as last statement of this block
          }
        } else if (
          metaData.status_code === 403 &&
          window.location.href !== this.legacyUrl
        ) {
          window.location.href = this.legacyUrl;
        } else {
          console.error("Meta call failed");
        }
      });
  }

  /**
   * It creates vs-peers tab's main state, which contains filters information
   * @param {object} metaData: response that we get from meta api
   * @param {array} updatedTickerInfo: list of formatted tickers
   */
  createvsPeerTab(metaData: any, updatedTickerInfo) {
    this.state.vsPeerTab = {
      ticker_info: updatedTickerInfo,
      currency: metaData.currency,
      period: metaData.period,
      ratios: metaData.ratios,
      period_calculation: metaData.period_calculation,
      defaultOrientation: metaData.orientation,
      magnitudeMsg: metaData.magnitude_message,
    };
  }

  /**
   * It creates company tab's main state, which contains filters information
   * @param {object} metaData: response that we get from meta api
   * @param {array} updatedTickerInfo: list of formatted tickers
   */
  createCompanyTab(metaData: any, updatedTickerInfo) {
    this.state.companyTab = {
      ticker_info: updatedTickerInfo,
      currency: metaData.currency,
      period: metaData.period,
      ratios: metaData.ratios,
      period_calculation: metaData.period_calculation,
      magnitudeMsg: metaData.magnitude_message,
    };
  }

  /**
   * It creates charts tab's main state, which contains filters information
   * @param {object} metaData: response that we get from meta api
   * @param {array} updatedTickerInfo: list of formatted tickers
   */
  createChartTab(metaData: any, updatedTickerInfo) {
    this.state.chartTab = {
      ticker_info: updatedTickerInfo,
      period: metaData.period,
      revision: metaData.revision,
      scaleType: metaData.scale_type,
      ratios: metaData.ratios,
      period_calculation: metaData.period_calculation,
      magnitudeMsg: metaData.magnitude_message,
    };
  }

  /**
   * It updates scaleType property of chart tab's state
   * @param {string} newScaleType: selected scale type
   */
  updateScaleType(newScaleType) {
    this.state.chartTab = {
      ...this.state.chartTab,
      scaleType: newScaleType,
    };
  }

  /**
   * It updates revision property of chart tab's state
   * @param {string} newRevision: selected revision
   */
  updateRevision(newRevision) {
    this.state.chartTab = {
      ...this.state.chartTab,
      revision: newRevision,
    };
  }

  /**
   * It updates ticker list of chart tab's state
   * @param {array} peers: selected ticker
   */
  updateChartPeers(peers) {
    this.state.chartTab = {
      ...this.state.chartTab,
      ticker_info: peers,
    };
  }

  /**
   * It updates given property of vsPeers tab
   * @param {objet} obj: oject to update
   */
  updatevsPeerTabData(obj) {
    this.state.vsPeerTab = {
      ...this.state.vsPeerTab,
      ...obj,
    };
    this.store.dispatch(new DeleteDpParams());
  }

  /**
   * It updates given property of company tab
   * @param {objet} obj: oject to update
   */
  updateCompanyTabData(obj) {
    this.state.companyTab = {
      ...this.state.companyTab,
      ...obj,
    };
    this.store.dispatch(new DeleteDpParams());
  }

  /**
   * It updates given property of chart tab
   * @param {objet} obj: oject to update
   */
  updateChartTabData(obj) {
    this.state.chartTab = {
      ...this.state.chartTab,
      ...obj,
    };
    this.store.dispatch(new DeleteDpParams());
  }

  /**
   * Executes on tab switch
   * Fires meta call on tab switch
   * Meta call for that specific tab should be fired only on the initial tab switch, for that we check if tab is already initialized or not
   * Also it should not fire multiple meta call for the same tab when the previous meta call is in progress. i.e. when user switches tabs even before the meta call gets resolved.
   * @param {number} tabIndex: tab index of active tab
   */
  handleTabChange(tabIndex) {
    if (
      tabIndex === 0 &&
      !this.vsPeersTabInitialized &&
      !this.isVsPeerMetaInProgress
    ) {
      this.getMeta(0, this.currentTicker);
    } else if (
      tabIndex === 1 &&
      !this.companyTabInitialized &&
      !this.isCompanyMetaInProgress
    ) {
      this.getMeta(1, this.currentTicker);
    } else if (
      tabIndex === 2 &&
      !this.chartTabInitialized &&
      !this.isChartMetaInProgress
    ) {
      this.getMeta(2, this.currentTicker);
    }

    if (tabIndex === 2) {
      this.selectedTab = "chartTab";
    } else if (tabIndex === 1) {
      this.selectedTab = "companyTab";
    } else {
      this.selectedTab = "vsPeerTab";
    }
    this.store.dispatch(new DeleteDpParams());
  }

  /**
   * It Updates the ticker_info value of state object with emitted values.
   * It updates the state object according to tab index
   * It updates ticker suggestion list
   * @param {object} tickers: list of selected tickers
   * @param {number} index: tab index from which function was emitted
   */
  handlePeersChange(tickers: Array<any>, index) {
    const peers = { ticker_info: tickers };
    if (index === 0) {
      this.updatevsPeerTabData(peers);
      this.getSuggestedTickerData(tickers);
    }
  }

  /**
   * Executes on click of Period calculation Apply button.
   * It posts the user period calculation related setting to api
   * It Updates the period_calculation value of state object with emitted values.
   * It updates the state object of both tab, since it is common for both tabs
   * @param {{ntmStmValue: string, calendariozationValue: string}, object} value: selected radio values from period calculation popup
   */
  handlePeriodCalculationChange({ value, userSettingDetails = {} }) {
    this.isUserPeriodCalSettingsInProgress = true;
    const periodCalculationDetails = {
      ntm_stm_method: value.ntmStmValue,
      calendarization_method: value.calendariozationValue,
    };
    this.dataService
      .saveUserPeriodCalculationSettings(periodCalculationDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          const objToUpdate = {
            period_calculation: periodCalculationDetails,
          };
          this.updatevsPeerTabData(objToUpdate);
          this.updateCompanyTabData(objToUpdate);

          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updatePeriodCalculation,
            getExtraLogDetails(
              this.currentCompanyId,
              this.selectedTabIndex === 1
                ? COMPANY_TAB.label
                : VS_PEER_TAB.label,
              userSettingDetails,
              periodCalculationDetails,
            ),
            "",
            VALUATION_PAGE,
          );
        }
        this.isUserPeriodCalSettingsInProgress = false;
      });
  }

  /**
   * It is call when this component is destroyed
   * Here we are unsubscribing the subscription, to prevent memory leaks
   */
  ngOnDestroy() {
    if (this.routeParamSubscriber) {
      this.routeParamSubscriber.unsubscribe();
    }
    if (this.dataService) {
      this.dataService.destroyValuationGridData();
    }
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
  }

  /**
   * Creates watchlist data object required for peers filter
   */
  getCompleteSuggestedAndWatchlistData() {
    const suggestedPeers = this.suggestedPeers;
    const watchlistAndRecentlyVisitedCompanies =
      this.watchListAndRecentCompaniesData;
    let result = [];
    if (suggestedPeers && suggestedPeers.length) {
      const peerComps =
        this.suggestedPeers.map((item) => {
          const company = {
            name: item.name,
            full_name: item.name,
            sli_comps_id: item.sli_comps_id || 0,
            ticker: item.ticker,
            mpt: item.mpt,
            isSelected: false,
            cid: item.cid,
            tickerDeleteDisabled: item.ticker === this.currentTicker,
          };
          return company;
        }) || [];

      const peerData = {
        watchername: "Suggested Peers",
        company_info: peerComps,
      };
      result = result.concat(peerData, watchlistAndRecentlyVisitedCompanies);
    } else {
      result = result.concat(watchlistAndRecentlyVisitedCompanies);
    }
    this.watchlistData = result;
  }

  /**
   * Makes call to get Watchlist and Recently viewed companies data and update them.
   */
  getWatchListAndRecentCompaniesData() {
    this.isWatchListAndRecentCompDataReady = false;
    const primaryTicker = this.currentTicker;
    this.compDataService.getWatchlists().subscribe((resp) => {
      this.watchListAndRecentCompaniesData = JSON.parse(
        JSON.stringify(resp.data),
      );
      const apiCalls = [this.compDataService.getRecentlyVisitedCompanies()];
      forkJoin(apiCalls).subscribe((res) => {
        this.store.dispatch(new SetDisableActions(false));
        if (res[0] && res[0].status === "success") {
          this.recentlyVisitedCompanies = this.appService.cloneArray(
            res[0].data,
          );
        }
        const recentViewCompanies = this.recentlyVisitedCompanies.map((el) => {
          const company = {
            name: el.name,
            ticker: el.ticker,
            sli_comps_id: el.sli_comps_id || 0,
            mpt: el.mpt,
            isSelected: false,
            cid: el.cid,
            tickerDeleteDisabled: el.ticker === primaryTicker,
          };
          return company;
        });

        const recentViewCompany = {
          watchername: "Recently viewed (up to 30)",
          company_info: recentViewCompanies,
        };

        this.watchListAndRecentCompaniesData.unshift(recentViewCompany);

        for (let i = 0; i < this.watchListAndRecentCompaniesData.length; i++) {
          const parsedWatchlistData = this.watchListAndRecentCompaniesData[
            i
          ].company_info.map((el) => {
            let company = {};
            company = {
              full_name: el.name,
              name: el.name,
              sli_comps_id: el.sli_comps_id || 0,
              ticker: el.ticker,
              mpt: el.mpt,
              isSelected: false,
              cid: el.companyid || el.cid,
              tickerDeleteDisabled: el.ticker === primaryTicker,
            };
            el = company;
            return el;
          });
          this.watchListAndRecentCompaniesData[i].company_info = JSON.parse(
            JSON.stringify(parsedWatchlistData),
          );
        }
        this.getCompleteSuggestedAndWatchlistData();
        this.isWatchListAndRecentCompDataReady = true;
      });
    });
  }

  /**
   * It updates the suggested tickers list.
   */
  getSuggestedTickerData(tickersInfo: Array<any>) {
    if (!this.currentTicker) {
      return;
    }
    this.isPeersDataReady = false;
    const limit = (tickersInfo || []).length + 10;

    if (!this.fetchedWatchlistData) {
      this.fetchedWatchlistData = true;
      this.getWatchListAndRecentCompaniesData();
    }

    this.compDataService
      .getCompanyPeers([this.currentTicker], null, limit, false, true)
      .subscribe((res) => {
        if (res && res.status === "success") {
          const peerInfo = res.peer_info || [];
          const responsePeers =
            peerInfo.reduce(function (result, item) {
              const checkIfSuggestedTickerAlreadyExists = tickersInfo.find(
                (selectedTicker) => selectedTicker.ticker === item.ticker,
              );
              if (!checkIfSuggestedTickerAlreadyExists) {
                const updatedTicker = { ...item, full_name: item.name };
                result.push(updatedTicker);
              }
              return result;
            }, []) || [];

          this.suggestedPeers = responsePeers.slice(0, 10);

          this.getCompleteSuggestedAndWatchlistData();

          this.isPeersDataReady = true;
        }
      });
  }

  /**
   * This removes the given ticker from ticker list
   * It updates the suggested ticker list, due to new change
   * @param {object} ticker - ticker to remove
   */
  handleDeletePeer(ticker) {
    let tickerInfo: Array<Dictionary<any>> = [];
    tickerInfo = this.state.vsPeerTab.ticker_info;
    tickerInfo = tickerInfo.filter((_ticker) => {
      return _ticker.ticker !== ticker.ticker;
    });
    this.getSuggestedTickerData(tickerInfo);
    this.updatevsPeerTabData({ ticker_info: tickerInfo });
  }

  /**
   * This function parses the ratio object and calls the update method for the respective tab
   * @param e - ratio values
   * @param index - value used to denote the tab
   */
  updateRatios(e, index) {
    const ratios = {
      ratios: {
        include: e.include,
        ratio_details: e.ratios,
      },
    };
    if (index === 0) {
      this.updatevsPeerTabData(ratios);
    } else if (index === 1) {
      this.updateCompanyTabData(ratios);
    } else if (index === 2) {
      this.updateChartTabData(ratios);
    }
  }

  /**
   * This function parses the currency and calls the update method for the respective tab
   * @param e - value of currency
   * @param index - value used to denote the tab
   */
  updateCurrency(e, index) {
    const currency = {
      currency: e.item,
      magnitudeMsg: e.magMsg,
    };
    if (index === 0) {
      this.updatevsPeerTabData(currency);
    } else if (index === 1) {
      this.updateCompanyTabData(currency);
    }
  }

  /**
   * Executes on click of Period filter popup's Apply button.
   * It posts the user period calculation related setting to api
   * It Updates the period value of state object with emitted values.
   * It updates the state object according to tabIndex, as it is specific to selected tab
   * @param {ValuationPeriodState} periodData: selected values in shape of period state from period filter popup
   */
  handlePeriodChange(periodData, index) {
    const objToUpdate = {
      period: periodData,
    };
    if (index === 0) {
      this.updatevsPeerTabData(objToUpdate);
    } else if (index === 1) {
      this.updateCompanyTabData(objToUpdate);
    } else if (index === 2) {
      this.updateChartTabData(objToUpdate);
    }
  }
}
